import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";
import { ToneOfVoice } from "@towersystems/roam-common/lib/generated-types";
import { GenerateProductDescriptionFormValues } from "../../components/GenerateProductDescriptionForm";

const ToneOptions = [
  {
    value: ToneOfVoice.PROFESSIONAL,
    label: "Professional",
    description: "A formal and polished tone suitable for business contexts",
  },

  {
    value: ToneOfVoice.FRIENDLY,
    label: "Friendly",
    description: "A warm and approachable tone that fosters connection",
  },
  {
    value: ToneOfVoice.CONCISE,
    label: "Concise",
    description: "A clear and brief tone that gets straight to the point",
  },
  {
    value: ToneOfVoice.ENTHUSIASTIC,
    label: "Enthusiastic",
    description: "An energetic and passionate tone that excites the reader",
  },
  {
    value: ToneOfVoice.FACTUAL,
    label: "Factual",
    description: "An objective and informative tone based on facts",
  },
];

export interface SelectProductDescriptionToneScreenProps
  extends StackScreenProps<any, "SelectProductDescriptionToneScreen"> {}

export const SelectProductDescriptionToneScreen = ({
  navigation,
}: SelectProductDescriptionToneScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } =
    useFormContext<GenerateProductDescriptionFormValues>();
  const watchedKeyType = getValues("toneOfVoice");
  const handleOnSelect = (code: string) => {
    setValue("toneOfVoice", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };

  return (
    <Page
      title={t("title.select_llm_tone")}
      secondaryTitle={t("title.select_llm_tone_secondary")}
    >
      <View>
        <FlatActionList
          items={ToneOptions.map((toneOption) => ({
            key: toneOption.value,
            title: toneOption.label,
            subTitle: toneOption.description,
            selected: toneOption.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(toneOption.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
